module.exports = __webpack_public_path__ + "img/page_1_header.9e96722e.png";